"use client"

import { useState, useEffect } from "react"
import { useLanguage } from "../LanguageContext"
import "../css/PasswordPrompt.css"

// Fallback copy, used only until /content/main/app-paywall.json loads (or if
// that fetch fails) so the prompt never renders blank.
const FALLBACK = {
  heading: { en: "Unlock All Current and New Lessons Instantly!", nl: "Ontgrendel Direct Alle Huidige en Nieuwe Lessen!" },
  price: { en: "€49 for 1 year (Family Access)", nl: "€49 voor 1 jaar (Jaartoegang per gezin)" },
  description: {
    en: "Pay €49 once for a full year of unlimited access for the whole family to every lesson – including everything new released during your year. No subscription, no auto-renewal (incl. 21% VAT).",
    nl: "Betaal één keer €49 en krijg een jaar lang onbeperkt toegang tot álle lessen voor het hele gezin – inclusief alle nieuwe die in jouw jaar verschijnen. Geen abonnement, geen automatische verlenging (incl. 21% btw).",
  },
  ctaButton: { en: "Start Learning Now", nl: "Begin direct met leren" },
  hasAccount: { en: "Already have an account?", nl: "Heb je al een account?" },
  loginLink: { en: "Log in here", nl: "Log hier in" },
}

// Same field-picker pattern as TeachersPage.tsx's L(): language code, else en, else fallback.
const L = (obj, langCode, fallback = "") => obj?.[langCode] || obj?.en || fallback

export function PasswordPrompt({ onPasswordSubmit, lessonTitle }) {
  const { language, translations } = useLanguage()
  const [paywall, setPaywall] = useState(null)

  useEffect(() => {
    fetch("/content/main/app-paywall.json")
      .then((res) => res.json())
      .then(setPaywall)
      .catch(() => {}) // keep FALLBACK on failure
  }, [])

  const handleSignupRedirect = () => {
    window.location.href = "/portal/register.php"
  }

  const handleLoginRedirect = () => {
    window.location.href = "/portal/login.php"
  }

  const src = paywall || FALLBACK
  const content = {
    heading: L(src.heading, language.code),
    price: L(src.price, language.code),
    description: L(src.description, language.code),
    ctaButton: L(src.ctaButton, language.code),
    hasAccount: L(src.hasAccount, language.code),
    loginLink: L(src.loginLink, language.code),
  }

  return (
    <div className="password-prompt-container">
      <div className="password-prompt-card">

        <h2 className="prompt-heading">{content.heading}</h2>

        <div className="price-tag">{content.price}</div>

        <p className="prompt-description">{content.description}</p>



        <button onClick={handleSignupRedirect} className="cta-button">
          {content.ctaButton} →
        </button>

        <p className="login-prompt">
          {content.hasAccount}{" "}
          <button onClick={handleLoginRedirect} className="login-link">
            {content.loginLink}
          </button>
        </p>
      </div>
    </div>
  )
}
